module.exports = __webpack_public_path__ + "img/profile_card2.97ea37f1.jpg";